import React, { Component } from "react";
import SimpleReactValidator from "simple-react-validator";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getPlanogramList } from "../../../../api/menu/master-files/planogram-maintenance/actions";
import { findItemValueByIdFromArray } from "../../../../functions/find-item-by-id-from-array";
import SearchSelect from "../../../common/SearchSelect";
import {
    deleteTrait, fetchTraitsList,
    insertTrait,
    updateTrait
} from "../../../../api/menu/master-files/traits/actions";
import Spinner from "../../../common/Spinner";

class TraitEditModal extends Component {
    constructor(props) {
        super(props);

        const { trait, jobId } = this.props;

        this.handleSave = this.handleSave.bind(this);

        const planogramId = trait ? trait.planogramId : null;
        this.state = {
            trait: {
                jobId,
                planogramId,
                traitDescription: trait ? trait.traitDescription : ""
            }
        };

        this.props.getPlanogramList();

        this.validator = new SimpleReactValidator({
            locale: "en",
            element: message => <div className="text-danger">{message}</div>
        });
    }

    handleSave = () => {
        if (this.validator.allValid()) {
            const {
                onCancel,
                jobId
            } = this.props;
            const { trait } = this.state;

            const callback = (status) => {
                if (status) {
                    this.props.fetchTraitJobs(jobId);
                    onCancel();
                }
            };

            this.setState({
                loading: true
            });
            if (this.props.trait) {
                trait.id = this.props.trait.id;
                this.props.updateTrait(trait.id, trait, callback);
            } else {
                this.props.insertTrait(trait, callback);
            }
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    render() {
        const { planogramList, loading, traitLoading } = this.props;
        const { trait } = this.state;
        const { planogramId, traitDescription } = trait;
        const options = planogramList.map(item => ({
            label: item.planogramCode,
            value: item.planogramId
        }));
        const currentOption = findItemValueByIdFromArray(
            options,
            "value",
            planogramId
        ) || null;

        return (
            <div className="position-relative">
                {!traitLoading || <Spinner />}

                <div className="row">
                    <div className="col-12">
                        <div className="form-group">
                            <label>Description</label>
                            <input
                                type="text"
                                className="form-control"
                                onChange={e => this.setState({
                                    trait: {
                                        ...trait,
                                        traitDescription: e.target.value
                                    }
                                })}
                                name="loginCode"
                                value={traitDescription || ""}
                            />
                            {this.validator.message("description", traitDescription, "required")}
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="form-group">
                            <label>Planogram</label>
                            <SearchSelect
                                className="custom-react-select"
                                options={options}
                                isLoading={loading}
                                isClearable={false}
                                isSearchable={true}
                                value={currentOption}
                                onChange={option => this.setState({
                                    trait: {
                                        ...trait,
                                        planogramId: option.value,
                                    }
                                })}
                            />
                        </div>
                    </div>
                </div>
                <div className="text-right">
                    <button className="btn btn-success mr-2" onClick={this.handleSave}>Save</button>
                    <button className="btn btn-danger" onClick={this.props.onCancel}>Cancel</button>
                </div>
            </div>
        );
    }
}

TraitEditModal.propTypes = {
    trait: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]).isRequired,
    jobId: PropTypes.number.isRequired,
    onCancel: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    planogramList: state.planogramMaintenance.planogramList,
    loading: state.planogramMaintenance.loading,
    traitLoading: state.traits.loading
});

const mapStateToDispatch = dispatch => ({
    getPlanogramList: bindActionCreators(getPlanogramList, dispatch),
    insertTrait: bindActionCreators(insertTrait, dispatch),
    updateTrait: bindActionCreators(updateTrait, dispatch),
    deleteTrait: bindActionCreators(deleteTrait, dispatch),
    fetchTraitJobs: bindActionCreators(fetchTraitsList, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(TraitEditModal);
